import { useEffect } from "react";
import { SITE_URL } from "@/constants/links";

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [type, key] = selector.replace("meta[", "").replace("]", "").split("=");
    el.setAttribute(type, key.replace(/"/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Sets <title>, description, canonical, and OG/Twitter tags per page.
 * The og_share.png lives at /brand/og_share.png (public folder).
 */
export const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const fullTitle = title;
    document.title = fullTitle;
    setMeta('meta[name="description"]', "content", description);
    const canonical = `${SITE_URL}${path}`;
    setLink("canonical", canonical);

    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[property="og:image"]', "content", `${SITE_URL}/brand/og_share.png`);
    setMeta('meta[property="og:type"]', "content", "website");

    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="twitter:image"]', "content", `${SITE_URL}/brand/og_share.png`);
  }, [title, description, path]);

  return null;
};
